module.exports = require('account-ion/lib/injectors');



// WEBPACK FOOTER //
// ./src/modules/account-ion/injectors.js